let setExceptionHandler = (cb: Function) => {
  cb('js', null);
};

export { setExceptionHandler };
